module.exports = __webpack_public_path__ + "static/media/curIndEquipos.b1a0c13d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/curIndEquipos.png
// module id = 972
// module chunks = 0